import Icon from "@core-components/icon/Icon";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import { EExternalRoutes } from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";

const ReviewBannerSmall: React.FC = () => {
  const { t } = useAppTranslation("components.reviewBannerSmall");
  const { navigate } = useAppNavigate();
  const completeStar = () => (
    <div className="mx-1 flex size-4 items-center justify-center rounded bg-trustpilot-default shadow-[0_0_7.3px_0_#00B67A80]">
      <Icon.TrustpilotStarWhite size={10} />
    </div>
  );

  const handleRating = () => {
    navigate(EExternalRoutes.TRUSTPILOT_REVIEWS, { openInNewTab: true });
  };

  return (
    <Group
      onClick={handleRating}
      justify="center"
      align="center"
      gap={10}
      className="hover-scale cursor-pointer rounded-md border-[0.5px] border-trustpilot-border border-solid bg-gradient-to-r from-trustpilot-darkest to-trustpilot-darker px-3 py-2 font-inter text-xs"
    >
      <Group align="center" justify="center" gap={0}>
        <SSWhiteText className="leading-[17px]">{t("excellent")}</SSWhiteText>
        {completeStar()}
        {completeStar()}
        {completeStar()}
        {completeStar()}
        {completeStar()}
      </Group>
      <Group gap={0}>
        <SSWhiteText className="leading-[17px]">
          <strong>100+ </strong>
          {t("reviewsOn")}
        </SSWhiteText>
        <Icon.TrustpilotStartFilled className="mx-1" size={16} />
        <SSWhiteText className="leading-[17px]">{t("trustpilot")}</SSWhiteText>
      </Group>
    </Group>
  );
};

export default ReviewBannerSmall;
